module.exports = __webpack_public_path__ + "img/timer_color_grey.3b686229.svg";